import { Actor, OrderStats } from "@sdk/shared/types/order.types";
import { Avatar, AvatarFallback } from "@shared/src/components/ui/avatar";
import { formatTimeLimit, getMerchantDisplayName, getMerchantInitials } from "@shared/src/utils/helpers";
import TextWithCopy from "@shared/src/components/common/misc/TextWithCopy";
import { ProcessedMerchantStats } from "@sdk/shared/lib/merchant-stats";

export interface OrderHeaderProps {
  tradeType: string;
  orderStats: OrderStats;
  actorAddress: string;
  username: string | null;
}

export function OrderHeader({ tradeType, username, orderStats, actorAddress }: OrderHeaderProps) {
  return (
    <div className="border-2 border-border-secondary rounded-3xl p-4 sm:p-6">
      <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-0 sm:justify-between">
        <div className="flex items-start">
          <div className="relative">
            <Avatar className="h-8 w-8 rounded-xl ">
              <AvatarFallback className="text-small">
                {getMerchantInitials({ account: { username: username } }, actorAddress)}
              </AvatarFallback>
            </Avatar>
            <span className="absolute bottom-0 right-0 size-1.5 rounded-full bg-text-success ring-2 ring-surfaces-bg-primary" />
          </div>
          <div className="ml-4 max-sm:text-small space-y-1">
            <div className="flex gap-2 items-center">
              <p className={`text-text-${tradeType === "buy" ? "error" : "success"} flex gap-2 font-medium`}>
                {tradeType === "buy" ? "Seller" : "Buyer"}
              </p>
              {getMerchantDisplayName({ account: { username: username } }, actorAddress)}
            </div>
            <TextWithCopy text={actorAddress} />
            <span className="font-extrabold text-text-primary break-words max-w-[200px]"></span>
            <div className="flex items-center gap-2 text-text-secondary text-micro2">
              <div className="flex items-center gap-1">
                (Rating)
                <span>{orderStats.positiveRates || "0"}%</span>
              </div>
              <div className="flex items-center gap-1">
                (Completion)
                <span>{formatTimeLimit(orderStats.completionRate)}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
